var map = {
	"./blue.png": "642e",
	"./color fluid.png": "c743",
	"./color fuild.png": "c4e2",
	"./fluid.png": "b9ee",
	"./glitch.png": "1e35",
	"./gold.png": "26e4",
	"./green.png": "ef9a",
	"./grey.png": "d855",
	"./orange.png": "8152",
	"./purple.png": "d661",
	"./red.png": "0662",
	"./vhs.png": "9990",
	"./yellow.png": "d6c0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9767";